export const HAS_DISMISSED_TOOLBAR_NO_UNDO = 'hasDismissedToolbarNoUndo';
export const HAS_SEEN_TOOLBAR_NO_UNDO = 'hasSeenToolbarNoUndo';
export const HAS_SEEN_UNREADABLE = 'hasSeenUnreadable';